import React from "react";
import Header from "../../../../layouts/header/Header";
import Footer from "../../../../layouts/footer/Footer";
import ImageAndTextCard from "./ImageAndTextCard";
import SearchIcon from "../../../../icons/SearchIcon";
import Stat from "../../home/stat/Stat";
import BagAboutus from "../../../../icons/Aboutus/BagAboutus";
import HandCoinsAboutus from "../../../../icons/Aboutus/HandCoinsAboutus";
import WindowAboutus from "../../../../icons/Aboutus/WindowAboutus";
import ChatsAboutus from "../../../../icons/Aboutus/ChatsAboutus";
import AboutUsCard from "./AboutUsCard";
import HandshakeIcon from "../../../../icons/HandshakeIcon";
import TiltArrow from "../../../../icons/TiltArrow";
import { ExploreAuctionPropertiesCard } from "./ExploreAuctionPropertiesCard";
import Alliances from "../../home/alliances/Alliances";
import WhyAB from "../../home/whyAB/WhyAB";

interface AboutUsData {
  heading: string;
  textContent?: string;
  icon?: React.ReactNode;
}

interface ExplorePropertiesData {
  className?: string;
  heading?: string;
  subheading?: string;
  imageLink?: string;
  propertyLink?: string;
  icon?: React.ReactNode;
}

const explorePropertiesData: ExplorePropertiesData[] = [
  {
    heading: "RESIDENTIAL ASSETS",
    subheading:
      "Planning to buy a residential house, villa, flat, or residential land.",
    imageLink: "./aboutus-v2/residential.png",
    propertyLink: "/residential-auction-properties",
    icon: (
      <TiltArrow
        fill="white"
        className="h-[42px] w-[42px]"
        bgFill={"transparent"}
      />
    ),
  },
  {
    heading: "COMMERCIAL ASSETS",
    subheading:
      "Planning to buy a residential house, villa, flat, or residential land.",
    imageLink: "./aboutus-v2/commercial.png",
    propertyLink: "/commercial-auction-properties",
    icon: (
      <TiltArrow
        fill="white"
        className="h-[42px] w-[42px]"
        bgFill={"transparent"}
      />
    ),
  },
  {
    heading: "INDUSTRIAL ASSETS",
    subheading:
      "Planning to buy a residential house, villa, flat, or residential land.",
    imageLink: "./aboutus-v2/industrial.png",
    propertyLink: "/industrial-auction-properties",
    icon: (
      <TiltArrow
        fill="white"
        className="h-[42px] w-[42px]"
        bgFill={"transparent"}
      />
    ),
  },
];

const aboutUsData: AboutUsData[] = [
  {
    heading: "E-Marketplace for NPA’s",
    textContent:
      "We provide a transparent platform for banks and housing finance companies to list their NPAs and find potential bidders without intermediaries.",
    icon: <BagAboutus className="h-11 w-11 lg:h-[60px] lg:w-[60px]" />,
  },
  {
    heading: "Financing Support for potential bidders",
    textContent:
      "We provide a transparent platform for banks and housing finance companies to list their NPAs and find potential bidders without intermediaries.",
    icon: <HandCoinsAboutus className="h-11 w-11 lg:h-[60px] lg:w-[60px]" />,
  },
  {
    heading: "Easy to use interface",
    textContent:
      "We provide a transparent platform for banks and housing finance companies to list their NPAs and find potential bidders without intermediaries.",
    icon: <WindowAboutus className="h-11 w-11 lg:h-[60px] lg:w-[60px]" />,
  },
  {
    heading: "E-Consulting",
    textContent:
      "We provide a transparent platform for banks and housing finance companies to list their NPAs and find potential bidders without intermediaries.",
    icon: <ChatsAboutus className="h-11 w-11 lg:h-[60px] lg:w-[60px]" />,
  },
];

export const AboutUsPage = () => {
  return (
    <>
      <Header />
      <div className="px-customPaddingMobile lg:px-customPadding py-8 lg:py-[110px] mt-2 lg:mt-0 2xl:w-[1340px] 2xl:mx-auto 2xl:px-0">
        <div className="lg:flex lg:flex-row-reverse  ">
          <div className="lg:ml-[58px] lg:py-5">
            <p className="font-spaceGrotesk font-normal text-mobile-h2 lg:text-web-h2 leading-9 lg:leading-[61px] text-brand-textBlack">
              INDIA’S FIRST MIDDLEMEN FREE Auction Platform
            </p>
            <p className="mt-2 lg:mt-8 font-openSans font-normal text-mobile-body-md lg:text-web-subheading leading-5 lg:leading-6 text-brand-textGrey">
              Auction Bazaar helps potential bidders to search for and bid on
              auction properties listed by banks, NBFCs, ARCs, and other
              financial institutions.
            </p>
          </div>
          <div className="flex  w-full mt-8 lg:mt-0 justify-bet ween  space-x-[14px]">
            <div className="w-2/3 flex flex-col justify-between">
              <div className="flex h-1/3 justify-between w-full space-x-4 ">
                <ImageAndTextCard
                  heading="Buy"
                  className="bg-brand-lightBlue clip-path-bottomLeftAboutUs w-1/2 min-h-20  "
                >
                  <img
                    className="max-w-[62px]"
                    src="/aboutus-v2/image4.png"
                    alt=""
                  />
                </ImageAndTextCard>
                <ImageAndTextCard
                  heading="Search"
                  className="bg-[#FEECE6] clip-path-bottomLeftAboutUs min-h-20 w-1/2"
                >
                  <div className="relative h-auto flex flex-col justify-end">
                    <img
                      className="max-w-[65px] md:max-w-[200px]"
                      src="/aboutus-v2/image2.png"
                      alt=""
                    />
                    <SearchIcon
                      fill="#666666"
                      className="absolute h-10 w-10 top-3 left-2"
                    ></SearchIcon>
                  </div>
                </ImageAndTextCard>
              </div>
              <img
                className="mt-2 w-full clip-path-bottomLeftAboutUs"
                src="/aboutus-v2/image1.png"
                alt=""
              />
            </div>
            <img
              className="clip-path-bottomLeftAboutUs w-1/3 h-auto"
              src="/aboutus-v2/image3.png"
              alt=""
            />
          </div>
        </div>
      </div>

      {/* Search Identify */}
      <div className="px-customPaddingMobile lg:px-customPadding  mt-4 2xl:w-[1340px] 2xl:mx-auto 2xl:px-0 bg-transparent">
        <div className="bg-[#F8F8F8] px-3 pt-8 lg:pt-[58px] lg:pl-[58px]  lg:flex">
          <div className="lg:pb-[66px]">
            <div className="hidden lg:flex pl-[6px] py-0.5 pr-4 clip-path-topRightFourSided font-openSans font-semibold text-mobile-body-lg leading-[22px] text-brand-orange bg-[#FEECE6] w-fit">
              MISSION
            </div>
            <p className="lg:mt-6 font-spaceGrotesk font-normal text-mobile-h2 lg:text-web-h3  mid:text-web-h2 leading-9 lg:leading-8 mid:leading-[61px] text-brand-textBlack">
              SEARCH, IDENTIFY, APPROACH, SIT BACK, AND BUY ONLINE
            </p>
            <p className="mt-2 lg:mt-4  font-openSans font-normal text-mobile-body-md lg:text-web-body-lg leading-5 lg:leading-[22px] text-brand-textLightGrey">
              Auction Bazaar helps potential bidders to search for and bid on
              auction properties listed by banks, NBFCs, ARCs, and other
              financial institutions. Best-in-class market rates, user-centric
              interface, and end-to-end solutions make us a complete platform
              for bidding on auctions.
            </p>
          </div>{" "}
          <img
            className="mt-[42px]  lg:ml-9 w-full"
            src="/aboutus-v2/image5.png"
            alt=""
          />
        </div>
      </div>

      <Stat />
      <div className="px-customPaddingMobile lg:px-[136px] mt-20 2xl:w-[1340px] 2xl:mx-auto 2xl:px-0">
        <iframe
          className="w-full h-[176px] sm:h-[300px] md:h-[400px] lg:h-[571px]"
          src="https://www.youtube.com/embed/awdUdZYQY54"
          frameBorder="0"
        ></iframe>
      </div>

      {/* Connecting Bidders */}
      <div className="px-customPaddingMobile lg:px-customPadding py-8 mt-4 lg:mt-20 2xl:w-[1340px] 2xl:mx-auto 2xl:px-0  lg:bg-[url('/wave2.png')]  bg-[position:calc(100%-0px)_-20px] bg-no-repeat">
        <p className="max-w-[784px] font-spaceGrotesk font-normal text-mobile-h2 lg:text-web-h2 leading-9 lg:leading-[61px] text-brand-textBlack">
          CONNECTING BIDDERS & FINANCIAL INSTITUTIONS
        </p>

        <div className="mt-8  space-y-[42px] lg:grid lg:grid-cols-2 lg:space-y-0 lg:gap-[42px]">
          {aboutUsData.map((card, index) => (
            <AboutUsCard
              key={`card-${index}`}
              heading={card.heading}
              textContent={card.textContent}
              icon={card.icon}
            />
          ))}
        </div>
      </div>

      {/* Explore Auction Properties */}
      <div className="pl-customPaddingMobile lg:px-customPadding py-8 lg:py-[50px]  mt-4 lg:mt-20 2xl:w-[1340px] 2xl:mx-auto 2xl:px-0">
        <div className="pr-customPaddingMobile lg:px-0">
          <p className="lg:mt-6 font-spaceGrotesk font-normal text-mobile-h2 lg:text-web-h3  mid:text-web-h2 leading-9 lg:leading-8 mid:leading-[61px] text-brand-textBlack">
            EXPLORE AUCTION PROPERTIES
          </p>
          <p className="mt-2 lg:mt-4  font-openSans font-normal text-mobile-body-sm lg:text-web-body-lg leading-4 lg:leading-[22px] text-brand-textLightGrey">
            Looking for a property you have always dreamed of? Experience a
            seamless choice of properties and stellar support by our experts at
            Auction Bazaar.
          </p>
        </div>

        <div className="flex overflow-x-auto scrollbar-hide lg:grid lg:grid-cols-3 gap-6 lg:gap-10 mt-7 lg:mt-[34px] ">
          {explorePropertiesData.map((card, index) => (
            <ExploreAuctionPropertiesCard
              key={`card-${index}`}
              imageLink={card?.imageLink}
              heading={card.heading}
              icon={card.icon}
              propertyLink={card.propertyLink}
              subheading={card.subheading}
            />
          ))}
        </div>
      </div>

      <WhyAB />
      <Alliances />

      {/* Lower Card */}
      <div className="lg:hidden clip-path-bottomRightUpcomingAuctionCard  px-customPaddingMobile ">
        <div className="bg-brand-lightBlue px-3 pt-3 pb-4">
          <div className="flex space-x-2">
            <HandshakeIcon />
            <p>Our Collaboration</p>
          </div>
          <p className="mt-1 font-openSans font-normal text-[10px] leading-[13px] text-brand-textLightGrey">
            We will structure an exceptional finance package with various
            alternate modes and assist ooth{" "}
          </p>
          <div className=" flex items-center mt-9  font-openSans font-normal text-mobile-body-sm leading-4 text-brand-textLightGrey">
            <img src="/aboutus-v2/image6.png" alt="" />
            <p className="w-[115px] mx-auto">
              1500 + properties in collaboration
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default AboutUsPage;
